import styled from "styled-components";

export const Wrapper = styled.div`
  .ant-tabs-nav {
    margin-bottom: 0px !important;
  }
`;
